import { useEffect } from 'react';

import { VStack } from 'src/components/core/Stack';
import { HighlightCardModal } from 'src/components/Insights/Catalog/HighlightCardModal';
import { useHighlightsPageContext } from 'src/components/Insights/Catalog/HighlightsPageProvider';
import { HighlightsPageToolbar } from 'src/components/Insights/Catalog/HighlightsPageToolbar';
import FilterableHighlightGrid from '../Filters/FilterableHighlightGrid';

export default function HighlightsPage() {
  const { selectedEntry, selectEntry, showModal, hideModal } =
    useHighlightsPageContext();

  useEffect(() => {
    if (!selectedEntry) return;

    hideModal(); // hides previous highlight modal when using carousel nav
    showModal(<HighlightCardModal />, {
      onClose: () => selectEntry(),
      withCodebook: true,
      containerStyle: {
        background: 'transparent',
        maxHeight: 'unset',
        height: '100%',
        pointerEvents: 'none',
        width: '90%',
        maxWidth: '856px',
      },
    });
  }, [selectedEntry]);

  return (
    <VStack margin="0 auto" flexGrow={1}>
      <HighlightsPageToolbar />
      <FilterableHighlightGrid />
    </VStack>
  );
}
